// extracted by mini-css-extract-plugin
export default {"touchTarget":"DiscountPresetsSettings_touchTarget__e-nPf"};